// infcode_change - metrics foundation
import { InstallationBuildKind, InstallationVersion } from "@opencode-ai/core/installation/version"
import type { MetricsRuntimeModule } from "./runtime-types"

export type MetricsTrackingEnv = "dev" | "prod"

const PREVIEW_INSTALLATION = /^0\.0\.0-/

function normalized(value: string | undefined) {
  return value?.trim().toLowerCase()
}

export function isMetricsTestProcess(env: Record<string, string | undefined> = process.env): boolean {
  if (env.KILO_TEST_HOME) return true
  if (env.KILO_TEST_MANAGED_CONFIG_DIR) return true
  if (normalized(env.INFCODE_EVENT_TRACKING_ENV) === "test") return true
  if (normalized(env.NODE_ENV) === "test") return true
  return false
}

export function resolveMetricsTrackingEnv(
  env: Record<string, string | undefined> = process.env,
): MetricsTrackingEnv {
  const explicit = normalized(env.INFCODE_EVENT_TRACKING_ENV)
  if (explicit === "prod" || explicit === "production") return "prod"
  if (explicit === "dev" || explicit === "development" || explicit === "test" || explicit === "local") {
    return "dev"
  }

  if (isMetricsTestProcess(env)) return "dev"
  if (InstallationBuildKind !== "release") return "dev"
  if (InstallationVersion === "local") return "dev"
  if (PREVIEW_INSTALLATION.test(InstallationVersion)) return "dev"

  return "prod"
}

export function resolveMetricsSdkEnv(
  runtime: Pick<MetricsRuntimeModule, "Env">,
  trackingEnv: MetricsTrackingEnv,
): number {
  return trackingEnv === "prod" ? runtime.Env.Prod : runtime.Env.Dev
}
